/**
 * Shared `DeleteButton` hard-delete checkbox config for order delete modals.
 * Calls `DELETE /v1/orders/{id}/?hard_delete=true` when checked.
 */
export const ORDER_HARD_DELETE_OPTION = {
  enabled: true,
  label: 'מחיקה ללא עדכון מלאי',
  hint: 'ההזמנה תימחק לצמיתות. מלאי המוצרים לא יעודכן.',
};
